import axios from 'axios';
import { base_URL } from '../config/config';

const API_BASE_URL = `${base_URL}/api`;

export const completeGoogleProfile = async (userData, token) => {
  try {
    const response = await axios.put(
      `${API_BASE_URL}/auth/complete-google-profile`,
      userData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error completing Google profile:', error);
    throw error;
  }
};

export const updateGoogleUserProfile = async (profileData, token) => {
  try {
    const response = await axios.patch(
      `${API_BASE_URL}/auth/google-user-profile`,
      profileData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating Google user profile:', error);
    throw error;
  }
};
